import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { POSTS } from '@/content/posts';
import { ArrowUpRight } from '@phosphor-icons/react';

export default function Blog() {
  useEffect(() => {
    document.title = 'Blog — Go Convert Documents (Free Online Document Converter)';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        'content',
        'Guides on converting PDF, Word, Excel, PowerPoint and images. Learn how to merge, split, compress and OCR files free online.'
      );
    }
    return () => {
      document.title = 'Go Convert Documents — Free Online Document Converter';
      if (meta) meta.setAttribute('content', 'Convert any file format to PDF, Word, Excel, PowerPoint, and more. Fast, secure, no registration required.');
    };
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 py-16">
      <p className="text-xs font-mono-plex uppercase tracking-widest text-zinc-500">
        Blog
      </p>
      <h1
        data-testid="blog-title"
        className="font-display font-bold text-4xl md:text-6xl leading-tight text-slate-950 mt-2"
      >
        Guides &amp; tips for<br />
        <span className="bg-black text-white px-2">document conversion</span>
      </h1>
      <p className="text-zinc-700 mt-6 max-w-2xl leading-relaxed">
        Free how-to articles for converting, merging, protecting and OCR-ing PDFs and Office documents. Written by the team behind Go Convert Documents.
      </p>

      <div data-testid="blog-list" className="mt-12 grid md:grid-cols-2 gap-6">
        {POSTS.map((p, i) => (
          <Link
            key={p.slug}
            to={`/blog/${p.slug}`}
            data-testid={`blog-card-${p.slug}`}
            className="card-in group border-2 border-black bg-white p-6 brutal-shadow flex flex-col"
            style={{ animationDelay: `${i * 60}ms` }}
          >
            <p className="text-[10px] font-mono-plex uppercase tracking-widest text-zinc-500">
              {new Date(p.date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
            </p>
            <h2 className="font-display font-semibold text-2xl leading-tight text-slate-950 mt-2">
              {p.title}
            </h2>
            <p className="text-zinc-600 text-sm mt-3 leading-relaxed">{p.description}</p>
            <span className="mt-6 inline-flex items-center gap-1 text-sm font-semibold group-hover:translate-x-1 transition-transform">
              Read article <ArrowUpRight weight="bold" size={16} />
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
